<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content>
  <!-- <div [innerHTML]="data.message"></div> -->

  <form [formGroup]="dataAccessForm" class="mb-4 mt-2">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.userRolesForm.collection' | translate}}</mat-label>
        <mat-select formControlName="collection" >
          @for (col of collectionList; track col) {
            <mat-option [value]="col.col" [disabled]="checkExistingCollection(col.col)">{{col.title | translate}}</mat-option>
          }
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.userRolesForm.rights' | translate}}</mat-label>
        <mat-select formControlName="rights" multiple>
          @for (right of rightsList; track right) {
            @if (right?.only && right.only?.includes(dataAccessForm.value.collection) ) {
              <mat-option [value]="right.type">{{right.translate | translate}}</mat-option>
            }
          }
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>{{'FORM.userRolesForm.filter' | translate}}</mat-label>
      <mat-select formControlName="filters" multiple>
        <mat-option>
          <ngx-mat-select-search [formControl]="filtersFilterCtrl"
            placeholderLabel="{{'search' | translate}}..."
            noEntriesFoundLabel="{{'no_results' | translate}}">
          </ngx-mat-select-search>
        </mat-option>
        @for (filter of filteredFiltersList$ | async; track filter) {
          <mat-option [value]="filter.type">{{filter.title ? filter.title : (filter.translate | translate)}}</mat-option>
        }
      </mat-select>
  </mat-form-field>
  </form> 
</mat-dialog-content>


<mat-dialog-actions>
    <button mat-button (click)="onCancel()" class="second-btn">{{'gen_dialog_btn_cancle' | translate}}</button>
    <button mat-button cdkFocusInitial class="first-btn" (click)="onConfirm()" [disabled]="dataAccessForm.invalid">{{'gen_dialog_btn_ok' | translate}}</button>
</mat-dialog-actions>